import React from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import { useForm, Form, Field } from '../../form'
import Button from '@material-ui/core/Button'
import { removeInvoiceFeeFormValidate } from '../../containers/validate'

class RemoveInvoiceFeeDialog extends React.Component {
  render() {
    return <RemoveInvoiceFeeDialogComponent {...this.props} />
  }
}

const styles = (theme) => ({
  button: {
    margin: theme.spacing(1),
    [theme.breakpoints.down('380')]: {
      width: '90%',
      margin: '8px 15px'
    }
  },
  textField: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    fontSize: '15px',
    lineHeight: '150%'
  }
})

const defaultValues = {
  notes: ''
}

const RemoveInvoiceFeeDialogComponent = ({
  classes,
  cancelDialog,
  feeType,
  updateAdminInvoiceStatusToNew
}) => {
  const form = useForm({
    name: 'removeInvoiceFeeForm',
    onSubmit: onSubmit,
    defaultValues: defaultValues,
    validator: removeInvoiceFeeFormValidate,
    resetOnSubmit: false
  })

  const { control } = form

  function onSubmit(values) {
    cancelDialog()
    if (feeType == 'remind') {
      updateAdminInvoiceStatusToNew(24, values.notes)
    } else if (feeType == 'recover') {
      updateAdminInvoiceStatusToNew(25, values.notes)
    }
  }

  function cancel(e) {
    cancelDialog(e)
  }

  return (
    <div>
      <Form {...form}>
        <div className="container-fluid">
          <div className="row">
            <div className="dashboard-content-header">
              <div className="panel panel-default">
                <div className="panel-heading">
                  <h3 className="panel-title">
                    {feeType == 'recover'
                      ? 'Ilmoita syy laskutusmaksun poistamiseen.Tämä toimenpide ei hylkää laskun perintää Resoniasta'
                      : 'Ilmoita syy laskutusmaksun poistamiseen'}
                  </h3>
                </div>
                <div className="panel-body">
                  <Field
                    name="notes"
                    inputType="textfield"
                    variant="outlined"
                    className={classes.textField}
                    control={control}
                    multiline
                  />
                </div>
              </div>
              <div>
                <ul className="nav nav-pills pull-right">
                  <li>
                    <Button
                      variant="outlined"
                      className={classes.button}
                      onClick={cancel}
                    >
                      Peruuta
                    </Button>
                  </li>
                  <li>
                    <Button
                      variant="contained"
                      className={classes.button}
                      type="submit"
                    >
                      Tallenna
                    </Button>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </Form>
    </div>
  )
}

RemoveInvoiceFeeDialog.propTypes = {
  classes: PropTypes.object.isRequired
}

export default withStyles(styles)(RemoveInvoiceFeeDialog)
